<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-text>
        <v-icon @click="drawer = false"> close </v-icon>
      </v-card-text>
      <v-card-title>Connect Core Products</v-card-title>
      <v-card-subtitle>
        <v-row dense>
          <v-col cols="auto">
            <span class="font-weight-bold">Category</span>
            {{ product.category }}
          </v-col>
          <v-col cols="auto">
            <span class="font-weight-bold">Provider</span>
            {{ print_provider_name(product.providerId) }}
          </v-col>
          <v-col
            v-if="product.material"
            cols="auto"
          >
            <span class="font-weight-bold">Material</span>
            {{ product.material.name }}
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-divider />
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row
            v-for="(item, i) in core_products_show"
            :key="i"
          >
            <v-col>
              <v-checkbox
                v-model="item.selected"
                :label="item.name"
                hide-details
                class="mt-0 pt-0"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { cloneDeep, orderBy } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'PrintEditCoreProducts',

  data() {
    return {
      product: {},
      valid: false,
      drawer: false,
      saving: false,
      coreProductId: null,
      core_products_show: []
    };
  },
  computed: {
    ...mapGetters({
      core_products: 'lookup/standard_products',
      core_product_name: 'lookup/product_name',
      print_provider_name: 'lookup/print_provider_name'
    })
  },
  methods: {
    show(product) {
      this.product = cloneDeep(product);
      this.core_products_show = orderBy(
        this.core_products
          .filter((x) => x.active)
          .map((x) =>
            Object.assign(x, {
              selected: this.product.coreProducts.filter((y) => y.id === x.id).length
            })
          ),
        ['selected'],
        ['desc']
      );
      this.drawer = true;
    },
    save() {
      this.saving = true;
      this.$store
        .dispatch('print/updateCoreProducts', {
          productId: this.product.id,
          coreProducts: this.core_products_show.map((x) => ({
            coreProductId: x.id,
            ignore: !x.selected
          }))
        })
        .then(() => {
          this.drawer = false;
          this.$emit('save');
          this.$root.$snackbarSuccess('Core products updated');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
